import Vue from "vue";
import Router from "vue-router";

import Search from "../components/Search.vue";
import About from "../components/About.vue";
import Tracks from "../components/Tracks";
import Speakers from "../components/Keynotes";

import Schedules from "../components/Schedules";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: __dirname,
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: "/grid/pt/21"
    },
    {
      path: "/17-pt",
      name: "17",
      component: Schedules,
      props: { language: "pt", day: 17 }
    },
    {
      path: "/18-pt",
      name: "18",
      component: Schedules,
      props: { language: "pt", day: 18 }
    },
    {
      path: "/19-pt",
      name: "19",
      component: Schedules,
      props: { language: "pt", day: 19 }
    },
    {
      path: "/31-pt",
      name: "31",
      component: Schedules,
      props: { language: "pt", day: 31 }
    },
    {
      path: "/grid/:language/:day",
      name: "grid",
      component: Schedules
    },
    {
      path: "/grid/:language/:day/with-rooms/:rooms",
      name: "gridwithrooms",
      component: Schedules
    },
    {
      path: "/grid/:language/:day/:room",
      name: "gridroom",
      component: Schedules
    },
    {
      path: "/search/:language/:term",
      name: "search",
      component: Search
    },
    {
      path: "/tracks/:language/",
      name: "tracks",
      component: Tracks
    },
    {
      path: "/speakers/:language/",
      name: "speakers",
      component: Speakers
    },
    {
      path: "/info/:language/:uuid",
      name: "info",
      component: About
    },
    {
      path: "/eventos/:language/:day",
      name: "eventos",
      component: Schedules,
      props: { language: "pt" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js